import useSWR from 'swr';
import api from 'utils/api';
import type { PaginatedResponse } from 'types';
import type {
  PublishingAdminItem,
  PublishingAdminItemType,
  PublishingIngestRun,
  PublishingRosterArtist,
} from 'types/publishing';

export interface AdminItemsParams {
  page: number;
  limit: number;
  type?: PublishingAdminItemType;
  spotifyArtistId?: string;
}

export function usePublishingAdminItems(params: AdminItemsParams) {
  const { data, error, mutate } = useSWR<PaginatedResponse<PublishingAdminItem>>(
    ['admin-publishing-items', JSON.stringify(params)],
    () => api.publishing.getAdminItems({ params }),
    { revalidateOnFocus: false }
  );
  return {
    items: data?.data || [],
    pagination: data?.pagination || null,
    isLoading: !data && !error,
    error,
    refetch: () => mutate(),
  };
}

/** Roster of the current snapshot (admins only); `enabled=false` skips the request. */
export function usePublishingAdminArtists(enabled: boolean) {
  const { data, error } = useSWR<PublishingRosterArtist[]>(
    enabled ? 'admin-publishing-artists' : null,
    () => api.publishing.getAdminArtists(),
    { revalidateOnFocus: false }
  );
  return { artists: data || [], isLoading: enabled && !data && !error, error };
}

export function usePublishingIngestRuns(limit = 20) {
  const { data, error, mutate } = useSWR<PublishingIngestRun[]>(
    ['publishing-ingest-runs', limit],
    () => api.publishing.getIngestRuns({ params: { limit } }),
    { revalidateOnFocus: false }
  );
  return { runs: data || [], isLoading: !data && !error, error, refetch: () => mutate() };
}
